// removed by extract-text-webpack-plugin
module.exports = {"registered":"registered___2Dlab","register-for-auction":"register-for-auction___ds_Fj"};


//////////////////
// WEBPACK FOOTER
// ./src/components/RegisterLink/RegisterLink.scss
// module id = UUHK
// module chunks = 57